import React, { useState } from "react";
import { createComment } from "../../api/Comment";
import { toast } from "react-toastify";

interface SendModalComponentProps {
  productId: number;
  onClose?: (refresh?: boolean) => void;
}

export default function SendModalComponent({
  productId,
  onClose,
}: SendModalComponentProps) {
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (comment.trim().length < 3) {
      toast.error("Nội dung phải có ít nhất 3 ký tự.", {
        position: "bottom-right",
      });
      return;
    }

    setLoading(true);
    try {
      const success = await createComment(productId, comment.trim());
      if (success) {
        onClose?.(true);
      } else {
        toast.error("Gửi ý kiến thất bại. Vui lòng thử lại.", {
          position: "bottom-right",
        });
      }
    } catch (error) {
      toast.error("Có lỗi xảy ra khi gửi ý kiến. Vui lòng thử lại.", {
        position: "bottom-right",
      });
      console.error("Failed to submit comment:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      role="presentation"
      className="MuiDialog-root styles_loggedFormModal__QkhVv styles_dialog__sLwuc"
      style={{ position: "fixed", zIndex: 1300, inset: 0 }}
    >
      <div
        className="MuiBackdrop-root"
        aria-hidden="true"
        onClick={() => onClose?.(false)}
        style={{
          opacity: 1,
          transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          inset: 0,
        }}
      />

      <div
        className="MuiDialog-container MuiDialog-scrollPaper"
        role="presentation"
        tabIndex={-1}
        style={{
          opacity: 1,
          transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <div
          className="MuiPaper-root MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthSm MuiDialog-paperFullWidth MuiPaper-elevation24 MuiPaper-rounded"
          style={{
            maxWidth: 600,
            width: "100%",
            margin: 32,
            position: "relative",
            backgroundColor: "#fff",
          }}
        >
          <div className="styles_headerDialog__eP0xR">
            <div className="MuiDialogTitle-root styles_title__iDbGS">
              <h2 className="MuiTypography-root MuiTypography-h6">Ý kiến về sản phẩm</h2>
            </div>
          </div>

          <div
            className="MuiDialogContent-root styles_content__XFqhI"
            style={{ padding: "8px 24px" }}
          >
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="styles_formTextarea__ng5zd MuiBox-root css-0">
                <textarea
                  rows={3}
                  className="styles_input__htKbU"
                  maxLength={200}
                  placeholder="* Vui lòng nhập nội dung câu hỏi bằng tiếng Việt có dấu, tối thiểu 3 ký tự (Bắt buộc)"
                  name="question"
                  style={{
                    height: 85,
                    width: "100%",
                    border: "1px solid #ddd",
                    borderRadius: 4,
                    padding: 8,
                  }}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />

                <div
                  className="styles_textareaCount__pYuWE"
                  style={{ textAlign: "right", fontSize: "0.75rem", color: "#666" }}
                >
                  {comment.length}/200
                </div>
              </div>
            </form>
          </div>

          <div
            className="MuiDialogActions-root styles_actions__TKot9 MuiDialogActions-spacing"
            style={{ display: "flex", justifyContent: "flex-end", padding: 16 }}
          >
            <button
              className="styles_base__Pdm9S styles_contained__4kDf4 styles_colorSecondary__js_Iq styles_small__QTUmD"
              onClick={() => onClose?.(false)}
              disabled={loading}
              style={{ marginRight: 8 }}
              type="button"
            >
              Hủy
            </button>

            <button
              className="styles_base__Pdm9S styles_contained__4kDf4 styles_colorPrimary__NGf0C styles_small__QTUmD"
              onClick={handleSubmit}
              disabled={loading || comment.trim().length < 3}
              type="button"
            >
              {loading ? "Đang gửi..." : "Gửi"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}